import { render, staticRenderFns } from "./ModalAddValue.vue?vue&type=template&id=024de855&"
import script from "./ModalAddValue.vue?vue&type=script&lang=js&"
export * from "./ModalAddValue.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports